[
    
    {
      "isdefault": "true",
      "label": "Buy Sell Code",
      "mappingkey": "buySellCode",
      "columnname": "BuySellCode",
      "filterby": "IS",
      "values": "",
      "time": "",
      "datatype": "String",
      "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Quantity",
        "mappingkey": "shareQuantity",
        "db_columnname": "Quantity",
        "filterby": "=",
        "values": "",
        "time": "",
        "datatype": "Int",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Price Type",
        "mappingkey": "priceType",
        "db_columnname": "PriceType",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Limit Price",
        "mappingkey": "limitPrice",
        "db_columnname": "LimitPrice",
        "filterby": "=",
        "values": "",
        "time": "",
        "datatype": "float",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Time In Force",
        "mappingkey": "timeInForceCode",
        "db_columnname": "TimeInForce",
        "filterby": "",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Expiry Date",
        "mappingkey": "expiryDate",
        "db_columnname": "ExpiryDate",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "Date",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Expiry Time",
        "mappingkey": "expiryTime",
        "db_columnname": "ExpiryTime",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "DateTime",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Contra ID",
        "mappingkey": "contraID",
        "db_columnname": "ContraID",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Contra Acct",
        "mappingkey": "contraAct",
        "db_columnname": "ContraAcct",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Locate Info",
        "mappingkey": "locateInfo",
        "db_columnname": "LocateInfo",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Acct Restrict",
        "mappingkey": "acctRestrict",
        "db_columnname": "AcctRestrict",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Stop Price",
        "mappingkey": "stopPrice",
        "db_columnname": "StopPrice",
        "filterby": "=",
        "values": "",
        "time": "",
        "datatype": "float",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "OMS System",
        "mappingkey": "omsSystem",
        "db_columnname": "OMSSystem",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
 
    {
        "isdefault": "true",
        "ui_columnname": "Received From MPID",
        "mappingkey": "receivedFromMpid",
        "db_columnname": "ReceivedFromMPID",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Originating Desk",
        "mappingkey": "originatingDesk",
        "db_columnname": "OriginatingDesk",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Terminal User",
        "mappingkey": "terminalUser",
        "db_columnname": "TerminalUser",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Received Order Id",
        "mappingkey": "receivedOrderID",
        "db_columnname": "ReceivedOrderId",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "All Or None",
        "mappingkey": "allOrNone",
        "db_columnname": "AllOrNone",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Cancel By Cust",
        "mappingkey": "cancelByCust",
        "db_columnname": "CancelByCust",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Spl Handling Code",
        "mappingkey": "splHandlingCode",
        "db_columnname": "SplHandlingCode",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Delivery Instructions",
        "mappingkey": "deliveryInstructions",
        "db_columnname": "DeliveryInstructions",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Not Held",
        "mappingkey": "notHeld",
        "db_columnname": "NotHeld",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Do Not Reduce Increase",
        "mappingkey": "doNotReduceIncrease",
        "db_columnname": "DoNotReduceIncrease",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Limit Order Display",
        "mappingkey": "limitOrderDisplay",
        "db_columnname": "LimitOrderDisplay",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Program Trading",
        "mappingkey": "programTrading",
        "db_columnname": "ProgramTrading",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Negotiated Trade",
        "mappingkey": "negotiatedTrade",
        "db_columnname": "NegotiatedTrade",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Strategy",
        "mappingkey": "strategy",
        "db_columnname": "Strategy",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    },
    {
        "isdefault": "true",
        "ui_columnname": "Strategy Details",
        "mappingkey": "strategyDetails",
        "db_columnname": "StrategyDetails",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": true
    }
]